// extracted by mini-css-extract-plugin
var _1 = "logo-trees";
export { _1 as "logo-trees" }
